import chat from './chat'

export default {
  namespaced: true,
  modules: {
    chat,
  }
}
